module.exports = __webpack_public_path__ + "static/media/event-3.0e2b6603.jpg";